import { Country } from '../../countries/shared';

export class Reseller {
  _id?: string;
  name: string = '';
  image: string = '';
  url: string = '';
  type: number = 1;
  country: Country;
  position: number = 0;
  active: boolean = false;
  created: Date;
  updated: Date;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/resellers/shared/reseller.model.ts